var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#instagram_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M11.454 7.278a4.295 4.295 0 1 0 0 8.59 4.295 4.295 0 0 0 0-8.59m0 7.159a2.864 2.864 0 1 1 0-5.728 2.864 2.864 0 0 1 0 5.728m4.296-12.17H7.159a5.017 5.017 0 0 0-5.012 5.011v8.59A5.017 5.017 0 0 0 7.16 20.88h8.59a5.017 5.017 0 0 0 5.012-5.011V7.278a5.017 5.017 0 0 0-5.011-5.011m3.58 13.602a3.58 3.58 0 0 1-3.58 3.58H7.159a3.58 3.58 0 0 1-3.58-3.58V7.278a3.58 3.58 0 0 1 3.58-3.58h8.59a3.58 3.58 0 0 1 3.58 3.58zM17.181 6.92a1.074 1.074 0 1 1-2.148 0 1.074 1.074 0 0 1 2.148 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "instagram_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22.909v23.727H0z"
  })))));
};
export default SvgInstagram;